// extracted by mini-css-extract-plugin
export default {"section":"styles_section__Oh3rK","text":"styles_text__Dw06u"};